<div
  class="product-card grow fill flex flex--column relative"
  [class.secondary-variant-product-card]="isSecondaryVariant()"
>
  @if (useNewProductCardLayout()) {
    <div
      class="rounded-large surface-primary overflow-hidden"
      [class.border]="!isSecondaryVariant()"
      [class.white-bg]="!isSecondaryVariant()"
      [class.overflow-hidden]="!isSecondaryVariant()"
    >
      <div
        class="flex product-card-content-container"
        [class.content-container--no-image]="!image()"
        data-testid="product-card-content-container"
      >
        @if (image()) {
          <div
            class="relative flex flex--shrink0 overflow-hidden nordic-blue-900-bg product-card-image-container"
            [class.rounded-large]="isSecondaryVariant()"
          >
            <fcom-image
              class="picture block flex--self-stretch"
              [imageData]="image()"
              [ratio]="isLaptopUp() ? '16x9' : '21x9'"
              [scale]="false"
              [fillParent]="isSecondaryVariant() ? true : isLaptopUp()"
            />
            <ng-container *ngIf="productTags().length && showStackableLabels() && !isSecondaryVariant()">
              <div
                class="flex absolute flex--column ps-xsmall-y pr-xxsmall-x g-xxsmall fill product-card-tags-column"
                data-testid="product-card-tags-column"
              >
                <fcom-tag
                  *ngFor="let productTag of productTags()"
                  data-testid="product-card-product-tag"
                  [theme]="productTag.theme"
                >
                  <fcom-icon *ngIf="productTag.icon" class="icon-small" [name]="productTag.icon" />
                  <span class="overflow-hidden truncate" [class.ms-xxsmall-l]="productTag.icon">{{
                    productTag.localizationKey | finLocalization: productTag.localizationParams
                  }}</span>
                </fcom-tag>
              </div>
            </ng-container>
          </div>
        }
        <div
          class="flex-1 flex flex--column pr-small-x product-card-content-column"
          [class.ps-medium-y]="!isSecondaryVariant()"
        >
          <ng-template #secondaryTags>
            <fcom-tag
              *ngFor="let productTag of productTags()"
              data-testid="product-card-product-tag"
              [theme]="productTag.theme"
            >
              <fcom-icon *ngIf="productTag.icon" class="icon-small" [name]="productTag.icon" />
              <span class="overflow-hidden truncate" [class.ms-xxsmall-l]="productTag.icon">{{
                productTag.localizationKey | finLocalization: productTag.localizationParams
              }}</span>
            </fcom-tag>
          </ng-template>
          <div class="flex flex--space-between">
            <h2 class="font-heading-4 font-title-bold" data-testid="product-card-title">
              {{ title() }}
            </h2>
            @if (productTags().length && isSecondaryVariant()) {
              <div class="dn-tablet-up flex flex--shrink0 flex--self-start g-xxsmall flex--wrap flex--end ps-small-l">
                <ng-container [ngTemplateOutlet]="secondaryTags" />
              </div>
            }
            <ng-container
              *ngIf="productTags().length && !countText() && !showStackableLabels() && !isSecondaryVariant()"
            >
              <div class="ps-small-l">
                <fcom-tag data-testid="product-card-product-tag" [theme]="productTags()[0].theme">
                  <fcom-icon *ngIf="productTags()[0]?.icon" class="icon-small" [name]="productTags()[0].icon" />
                  <span [class.ms-xxsmall-l]="productTags()[0]?.icon">{{
                    productTags()[0].localizationKey | finLocalization: productTags()[0].localizationParams
                  }}</span>
                </fcom-tag>
              </div>
            </ng-container>
          </div>
          @if (showDetailText() && detailText()) {
            <p data-testid="product-card-detail-text">{{ detailText() }}</p>
          }
          @if (productTags().length && isSecondaryVariant()) {
            <div class="dn-tablet-down flex g-xxsmall flex--wrap ps-xsmall-t" data-testid="product-card-tags-column">
              <ng-container [ngTemplateOutlet]="secondaryTags" />
            </div>
          }

          <div class="flex-1 flex flex--row flex--space-between product-card-actions">
            <div class="flex-1 flex flex--column flex--self-end">
              @if (!countText()) {
                @if (lowestPrice() || originalPrice()) {
                  <div class="flex flex--middle">
                    @if (!originalPrice()) {
                      <span class="font-body-2 font-body-small" data-testid="product-card-starting-from-label">{{
                        'pricesStartingFrom' | finLocalization
                      }}</span>
                    }

                    @if (originalPrice()) {
                      <div>
                        <span class="font-body-2 font-body-small" data-testid="product-card-starting-from-label">{{
                          'localSettings.ancillaries.productCard.originalPriceLabel' | finLocalization
                        }}</span>
                        <span
                          class="font-body-2 strike-through ps-xxsmall-l font-body-small"
                          data-testid="product-card-original-price"
                          >{{ originalPrice() }}</span
                        >
                      </div>
                    }
                  </div>
                  @if (lowestPrice()) {
                    <div class="flex flex--middle">
                      <span
                        class="font-heading-5 font-title-small heather-700-text text-icon-primary"
                        data-testid="product-card-price"
                        >{{ lowestPrice() }}</span
                      >
                      @if (aviosLowestPrice()) {
                        <span
                          class="nowrap font-body-1 medium-type ps-xxsmall-l flex flex--middle font-label-medium"
                          data-testid="product-card-avios-price"
                        >
                          /
                          <fcom-icon class="icon-small ms-xxsmall-x" [name]="SvgLibraryIcon.AVIOS_CURRENCY" />
                          {{ aviosLowestPrice() }}
                          {{ 'ancillaries.benefits.labels.plusPoints' | finLocalization }}
                        </span>
                      }
                    </div>
                  }
                }
              }
            </div>
            <div
              class="flex--self-end"
              [ngClass]="{ 'fill ps-xlarge-y': hideButton() && isLaptopUp() }"
              data-testid="cta-button-container"
            >
              @if (!hideButton()) {
                <fcom-button
                  class="block ps-xlarge-t flex--self-end"
                  [mode]="ButtonMode.INLINE"
                  [loading]="loading()"
                  [theme]="buttonTheme()"
                  [text]="buttonText()"
                  [icon]="{ name: buttonIcon(), position: buttonIconPosition() }"
                  [title]="buttonAriaText()"
                  [aria]="{
                    label: buttonAriaText(),
                    role: 'button',
                    loadingLabel: 'actions.loading' | finLocalization,
                  }"
                  [focusOnRender]="focusOnBtn()"
                  (clickBtn)="emitProductCategory($event)"
                />
              }
            </div>
          </div>
        </div>
      </div>

      @if (countText()) {
        <div
          class="border-top font-body-1 bold-type ps-xsmall-y pr-small-x flex font-body-medium-bold"
          data-testid="product-card-count-text"
        >
          <span>{{ countText() }}: {{ price() }}</span>
          @if (aviosPrice()) {
            <span
              class="font-body-1 medium-type ps-xxsmall-l flex flex--middle font-label-medium"
              data-testid="product-card-avios-price"
            >
              /
              <fcom-icon class="icon-small ms-xxsmall-x" [name]="SvgLibraryIcon.AVIOS_CURRENCY" />
              {{ aviosPrice() | finMap: 'amount' | finPoints }}
              {{ 'ancillaries.benefits.labels.plusPoints' | finLocalization }}
            </span>
          }
        </div>
      }

      @if (notificationText()) {
        <fcom-notification
          class="border-top"
          [theme]="notificationTheme()"
          [layout]="NotificationLayout.EDGE_TO_EDGE"
          [title]="notificationTitle()"
          [iconName]="notificationIcon()"
          [removeHorizontalPadding]="true"
        >
          <p [innerHTML]="notificationText() | finSafe: 'html'"></p>
        </fcom-notification>
      }
    </div>
  } @else {
    @if (image()) {
      <fcom-image
        class="picture block rounded-top-large border-top border-left border-right border"
        [ratio]="'21x9'"
        [imageData]="image()"
      />
    }

    <div
      class="flex-1 pr-small-x ps-medium-y white-bg surface-primary flex flex--column border-bottom border-left border-right border"
      [class.rounded-bottom-large]="!!image()"
      [class.rounded-large]="!image()"
      [class.border-top]="!image()"
    >
      <h2 class="nordic-blue-900-text text-icon-primary font-heading-4 font-title-medium">{{ title() }}</h2>

      @if (lowestPrice()) {
        <div class="flex flex--middle">
          <span class="font-body-2 ps-xxsmall-r font-body-small" data-testid="product-card-starting-from-label">{{
            'pricesStartingFrom' | finLocalization
          }}</span>
          <span
            [ngClass]="{
              'font-heading-5 font-title-small': !originalPrice(),
              'strike-through': originalPrice(),
              'font-body-2 font-body-small': originalPrice(),
            }"
            data-testid="product-card-starting-from-price"
            >{{ originalPrice() ? originalPrice() : lowestPrice() }}</span
          >
          @if (originalPrice()) {
            <span
              class="font-heading-5 heather-700-text text-icon-primary ps-xxsmall-l font-title-small"
              data-testid="product-card-discounted-price"
              >{{ lowestPrice() }}</span
            >
          }
          @if (enableAviosInMMB && aviosLowestPrice()) {
            <span
              class="font-body-1 medium-type ps-xxsmall-l flex flex--middle font-label-medium"
              data-testid="product-card-avios-price"
            >
              /
              <fcom-icon class="icon-small ms-xxsmall-x" [name]="SvgLibraryIcon.AVIOS_CURRENCY" />
              {{ aviosLowestPrice() }}
              {{ 'ancillaries.benefits.labels.plusPoints' | finLocalization }}
            </span>
          }
        </div>
      }

      <ng-container *ngIf="productTags().length">
        <fcom-tag data-testid="product-card-product-tag" [theme]="productTags()[0].theme">
          <fcom-icon *ngIf="productTags()[0]?.icon" class="icon-small" [name]="productTags()[0].icon" />
          <span [class.ms-xxsmall-l]="productTags()[0]?.icon">{{
            productTags()[0].localizationKey | finLocalization: productTags()[0].localizationParams
          }}</span>
        </fcom-tag>
      </ng-container>

      @if (detailText()) {
        <p class="ps-xsmall-t ps-small-b font-body-1 flex-1 font-body-medium">{{ detailText() }}</p>
      }

      @if (statusText() || purchasedText()) {
        <hr class="border-top-dashed nordic-blue-50-border border-primary" aria-hidden="true" />

        <div class="ps-small-y align-right">
          @if (purchasedText()) {
            <div class="nordic-blue-900-text text-icon-primary font-body-1 font-body-medium">
              {{ purchasedText() }}
            </div>
          }
          <div
            class="font-body-1 font-body-medium"
            [ngClass]="{
              'medium-type': hasAddedItems(),
              'nordic-nordic-blue-900-100-text': hasAddedItems(),
              'nordic-blue-900-text text-icon-primary': !hasAddedItems(),
            }"
          >
            {{ statusText() }}
          </div>
          @if (price()) {
            <div
              class="font-body-1 nordic-blue-900-text text-icon-primary font-body-medium flex flex--middle flex--end"
            >
              {{ price() }}
              @if (enableAviosInMMB && aviosPrice()) {
                <span class="ps-xxsmall-l">
                  /
                  <fcom-icon class="icon-small" [name]="SvgLibraryIcon.AVIOS_CURRENCY" />
                  {{ aviosPrice() | finMap: 'amount' | finPoints }}
                  {{ 'ancillaries.benefits.labels.plusPoints' | finLocalization }}
                </span>
              }
            </div>
          }
        </div>

        <hr class="border-top-dashed nordic-blue-50-border border-primary" aria-hidden="true" />
      }

      <div class="align-center">
        @if (!hideButton()) {
          <fcom-button
            class="block ps-small-t"
            [mode]="ButtonMode.FILL"
            [loading]="loading()"
            [theme]="buttonTheme()"
            [text]="buttonText()"
            [icon]="{ name: buttonIcon(), position: IconPosition.RIGHT }"
            [title]="buttonAriaText()"
            [aria]="{ label: buttonAriaText(), role: 'button', loadingLabel: 'actions.loading' | finLocalization }"
            [focusOnRender]="focusOnBtn()"
            (clickBtn)="emitProductCategory($event)"
          />
        }

        @if (notificationText()) {
          <fcom-notification
            class="block ps-small-y ps-small-t align-left"
            [theme]="notificationTheme()"
            [title]="notificationTitle()"
            [iconName]="notificationIcon()"
          >
            {{ notificationText() }}
          </fcom-notification>
        }
      </div>
    </div>
  }
</div>
